import React from 'react';
import {
  ClickAwayListener,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Drawer,
  Grow,
  Paper,
  Popper
} from '@mui/material';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { paperClasses } from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import { useWindowSize } from '../../../utils/hooks';
import { MOBILE_BREAKPOINT } from '../../../utils/constants';
import colors from '../../../scss/colors';

function DeleteDialog(props) {
  const { open, closeHandler, confirmHandler, config, pending = false } = props;
  const { t } = useTranslation();

  const size = useWindowSize();

  const deleteDialogContent = (
    <>
      <DialogContent
        sx={{
          ml: 4,
          mr: 4,
          p: 1.5
        }}
      >
        <DialogContentText
          id="alert-dialog-description"
          sx={{
            pt: 2,
            minHeight: 70,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            color: size.width > MOBILE_BREAKPOINT ? colors.NAVY_BLUE : colors.BLACK,
            fontSize: size.width > MOBILE_BREAKPOINT ? '16px' : '12px'
          }}
        >
          <p>{config.text}</p>
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          ml: 4,
          mr: 4,
          mb: 4,
          p: 0,
          justifyContent: 'space-around'
        }}
      >
        <Button
          onClick={closeHandler}
          variant="outlined"
          sx={{
            textTransform: 'none',
            mr: 1,
            minWidth: 105,
            color: colors.MEDIUM_GREY,
            fontSize: '12px',
            borderColor: colors.MEDIUM_GREY
          }}
        >
          {t('common.general.cancel')}
        </Button>
        <Button
          onClick={confirmHandler}
          variant="filled"
          disabled={pending}
          // color="error"
          sx={{
            textTransform: 'none',
            minWidth: 105,
            background: 'linear-gradient(180deg, rgba(0, 73, 118, 0) 0%, #004876 100%), #009ACE',
            color: colors.WHITE,
            fontSize: '12px',
            '&:hover': {
              background: 'linear-gradient(180deg, rgba(0, 73, 118, 0) 0%, #004876 100%), #009ACE'
            }
          }}
        >
          {t('common.general.yes')}
          {pending && (
            <CircularProgress
              size={24}
              sx={{
                color: colors.WHITE,
                position: 'absolute',
                top: '50%',
                left: '50%',
                marginTop: '-12px',
                marginLeft: '-12px'
              }}
            />
          )}
        </Button>
      </DialogActions>
    </>
  );

  return size.width > MOBILE_BREAKPOINT ? (
    <Dialog
      open={open}
      onClose={closeHandler}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        zIndex: 1700,
        '& .MuiDialog-paper': {
          borderRadius: '10px'
        }
      }}
    >
      {deleteDialogContent}
    </Dialog>
  ) : (
    <Popper open={open} role={undefined} placement="bottom-start" transition disablePortal>
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom'
          }}
        >
          <Paper>
            <ClickAwayListener onClickAway={closeHandler}>
              <Drawer
                anchor="bottom"
                open={open}
                onClose={closeHandler}
                sx={{
                  [`& .${paperClasses.root}`]: {
                    borderRadius: '10px 10px 0 0'
                  }
                }}
              >
                {deleteDialogContent}
              </Drawer>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
}

export default DeleteDialog;
